export default "__VITE_PUBLIC_ASSET__dae3fb2b__"